import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

function useMutationTeams<TData = unknown, TError = unknown, TVariables = unknown, TContext = unknown>(
  options: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationResult<TData, TError, TVariables, TContext> {
  return useMutation(options);
}

export default useMutationTeams;
